import { InnerBox } from "@/components/elements/InnerBox";
import { MatchInfoItem } from "@/features/match/components/match-info/MatchInfoItem";
import { MatchFileLink } from "@/features/match/components/match-info/MatchFileLink";
import { DATE_FORMAT } from "@/constants/datetime";
import { TMatchInfo } from "@/features/match/types/MatchInfo";
import { CollapsibleSectionHeader, useCollapsible } from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Collapse, Grid } from "@mui/material";
import dayjs from "dayjs";

type TMatchBasicInfoProps = {
  defaultValues: Partial<TMatchInfo>;
};

export const MatchBasicInfo: FCC<TMatchBasicInfoProps> = ({ defaultValues }) => {
  const { expanded, toggle } = useCollapsible();

  return (
    <InnerBox showDivider={false} padding={3} borderColor={divider.high}>
      <CollapsibleSectionHeader title="基本情報" expanded={expanded} onToggle={toggle} />

      <Collapse in={expanded}>
        <Grid mt={3} container spacing={2}>
          <Grid item xs={6}>
            <MatchInfoItem label="会社名" value={defaultValues?.matchName} />
          </Grid>
          <Grid item xs={6}>
            <MatchInfoItem label="会社名（ローマ字）" value={defaultValues?.matchNameRomaji} />
          </Grid>
          <Grid item xs={6}>
            <MatchInfoItem label="紹介事業許可番号" value={defaultValues.matchLicenseNumber} />
          </Grid>
          <Grid item xs={6}>
            <MatchInfoItem
              label="許可有効期限"
              value={defaultValues?.matchLicenseExpiryDate ? dayjs(defaultValues.matchLicenseExpiryDate).format(DATE_FORMAT) : null}
            />
          </Grid>
          <Grid item xs={4}>
            <MatchInfoItem label="代表者氏名" value={defaultValues?.representativeName} />
          </Grid>
          <Grid item xs={4}>
            <MatchInfoItem label="役職" value={defaultValues?.representativePosition} />
          </Grid>
          <Grid item xs={4}>
            <MatchInfoItem label="電話番号" value={defaultValues?.phoneNumber} />
          </Grid>

          <Grid item xs={12}>
            {defaultValues?.matchLicenseFilePath ? (
              <MatchFileLink label="許可証" filePath={defaultValues.matchLicenseFilePath} />
            ) : (
              <MatchInfoItem label="許可証" value={null} isShowDivider={false} />
            )}
          </Grid>
        </Grid>
      </Collapse>
    </InnerBox>
  );
};
